<template>
	<div class="wallet-page">
		<!-- 汇总 -->
		<div style="margin: 10px 0">
		截至目前：总分享量 {{ allCount.totalShareCount }}次,总点击量{{
			allCount.totalClickCount
		}}次，总消费次数{{ allCount.totalConsumeCount }}次,总消费金额{{ allCount.totalConsumeAmount }}元
		</div>
		
		<!-- 标签页（复用钱包统计的tab-box样式，增加tab-click事件） -->
		<el-tabs v-model="activeTab" @tab-click="changeSelectValue" type="card" class="tab-box">
			<!-- 转发统计 -->
			<el-tab-pane label="转发统计" name="forwardStat">
				<!-- 查询区域（对齐钱包统计的query-row结构） -->
				<div class="query-row">
					<div class="query-item">
						<span>时间:</span>
						<el-date-picker
								v-model="statQuery.dateRange"
								type="daterange"
								range-separator="-"
								separator="至"
								value-format="yyyy-MM-dd"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								clearable
						/>
					</div>
					<el-button type="primary" @click="queryStat">查询</el-button>
				</div>
				
				<!-- 转发统计表格（复用钱包统计的表格样式） -->
				<el-table
						:data="statList"
						border
						stripe
						header-align="center"
						align="center"
						size="medium"
				>
					<el-table-column label="系统日期" prop="dateTime" header-align="center" align="center"></el-table-column>
					<el-table-column label="总分享量" prop="shareCount" header-align="center" align="center">
						<template slot-scope="scope">
							<div style="padding: 5px 0">
								{{ scope.row.shareCount }}
							</div>
						</template>
					</el-table-column>
<!--					<el-table-column label="微信好友" prop="wxFriend"></el-table-column>-->
<!--					<el-table-column label="微信群" prop="wxGroup"></el-table-column>-->
<!--					<el-table-column label="朋友圈" prop="pyq"></el-table-column>-->
					<el-table-column label="点击量" prop="clickCount" header-align="center" align="center"></el-table-column>
					<el-table-column label="消费次数" prop="consumeCount" header-align="center" align="center"></el-table-column>
					<el-table-column label="消费金额" prop="consumeAmount" header-align="center" align="center"></el-table-column>
				</el-table>
				
				
				<!-- 转发统计分页（对齐钱包统计的分页结构） -->
				<div class="pager-box">
					<span>共{{ statTotal }}条</span>
					<el-pagination
							:page-sizes="[20,50,100]"
							:page-size="statPage.pageSize"
							:current-page="statPage.pageNum"
							:total="statTotal"
							layout="sizes, prev, pager, next, jumper"
							@size-change="statSizeChange"
							@current-change="statPageChange"
					/>
				</div>
			</el-tab-pane>
			
			<!-- 转发记录 -->
			<el-tab-pane label="转发记录" name="forwardRecord">
				<!-- 查询区域（对齐钱包明细的detail-query样式） -->
				<div class="query-row detail-query">
					<div class="query-item">
						<span>产品ID:</span>
						<el-input v-model="recordQuery.productId" placeholder="请输入产品ID" style="width:160px" clearable />
					</div>
					<div class="query-item">
						<span>用户姓名:</span>
						<el-input v-model="recordQuery.userName" placeholder="请输入用户姓名" style="width:160px" clearable />
					</div>
					<div class="query-item">
						<span>手机号:</span>
						<el-input v-model="recordQuery.phone" placeholder="请输入手机号" style="width:160px" clearable />
					</div>
					<div class="query-item time-box">
						<span>时间:</span>
						<el-date-picker
								v-model="recordQuery.dateRange"
								type="daterange"
								range-separator="-"
								separator="至"
								value-format="yyyy-MM-dd"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								clearable
								style="width:280px"
						/>
					</div>
					
					<el-button type="primary" @click="resetRecordQuery">重置查询条件</el-button>
					<el-button type="primary" @click="queryRecord">查询</el-button>
				</div>
				
				<!-- 转发记录表格（复用钱包统计的表格样式） -->
				<el-table
						:data="recordList"
						border
						stripe
						header-align="center"
						align="center"
						class="data-table"
				>
					<el-table-column label="产品ID" prop="code" header-align="center" align="center"></el-table-column>
<!--					<el-table-column label="分享者微信号" prop="shareWxId" header-align="center" align="center"></el-table-column>-->
					<el-table-column label="分享者姓名" prop="nickName" header-align="center" align="center">
						<template slot-scope="scope">
							<div style="padding: 5px 0">
								{{ scope.row.nickName }}
							</div>
						</template>
					</el-table-column>
					<el-table-column label="分享者手机" prop="phoneNumber" header-align="center" align="center"></el-table-column>
					<el-table-column label="分享时间" prop="createTime" header-align="center" align="center"></el-table-column>
<!--					<el-table-column label="分享类型" prop="shareType"></el-table-column>-->
					<el-table-column label="点击量" prop="clickCount" header-align="center" align="center"></el-table-column>
					<el-table-column label="消费次数" prop="consumeCount" header-align="center" align="center"></el-table-column>
					<el-table-column label="消费金额" prop="consumeAmount" header-align="center" align="center"></el-table-column>
				</el-table>
				
				<!-- 转发记录分页（对齐钱包统计的分页结构） -->
				<div class="pager-box">
					<span>共{{ recordTotal }}条</span>
					<el-pagination
							:page-sizes="[20,50,100]"
							:page-size="recordPage.pageSize"
							:current-page="recordPage.pageNum"
							:total="recordTotal"
							layout="sizes, prev, pager, next, jumper"
							@size-change="recordSizeChange"
							@current-change="recordPageChange"
					/>
				</div>
			</el-tab-pane>
			
			<!-- 点击记录 -->
			<el-tab-pane label="点击记录" name="clickRecord">
				<!-- 查询区域（对齐钱包明细的detail-query样式） -->
				<div class="query-row detail-query">
					<div class="query-item">
						<span>产品ID:</span>
						<el-input v-model="clickQuery.productId" placeholder="请输入产品ID" style="width:160px" clearable />
					</div>
					<div class="query-item">
						<span>用户姓名:</span>
						<el-input v-model="clickQuery.userName" placeholder="请输入用户姓名" style="width:160px" clearable />
					</div>
					<div class="query-item">
						<span>手机号:</span>
						<el-input v-model="clickQuery.phone" placeholder="请输入手机号" style="width:160px" clearable />
					</div>
					<div class="query-item time-box">
						<span>时间:</span>
						<el-date-picker
								v-model="clickQuery.dateRange"
								type="daterange"
								range-separator="-"
								separator="至"
								value-format="yyyy-MM-dd"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								clearable
								style="width:280px"
						/>
					</div>
					
					<el-button type="primary" @click="resetClickQuery">重置查询条件</el-button>
					<el-button type="primary" @click="queryClick">查询</el-button>
				</div>
				
				<!-- 点击记录表格（复用钱包统计的表格样式） -->
				<el-table
						:data="clickList"
						border
						stripe
						header-align="center"
						align="center"
						class="data-table"
				>
					<el-table-column label="产品ID" prop="code" header-align="center" align="center"></el-table-column>
<!--					<el-table-column label="分享者微信号" prop="shareWxId" header-align="center" align="center"></el-table-column>-->
					<el-table-column label="分享者姓名" prop="nickName" header-align="center" align="center">
						<template slot-scope="scope">
							<div style="padding: 5px 0">
								{{ scope.row.nickName }}
							</div>
						</template>
					</el-table-column>
					<el-table-column label="分享者手机" prop="phoneNumber" header-align="center" align="center"></el-table-column>
					<el-table-column label="分享时间" prop="shareTime" header-align="center" align="center"></el-table-column>
<!--					<el-table-column label="用户微信号" prop="userWxId"></el-table-column>-->
					<el-table-column label="用户名" prop="clickerNickName" header-align="center" align="center"></el-table-column>
					<el-table-column label="用户手机" prop="clickerPhoneNumber" header-align="center" align="center"></el-table-column>
					<el-table-column label="点击时间" prop="createTime" header-align="center" align="center"></el-table-column>
				</el-table>
				
				<!-- 点击记录分页（对齐钱包统计的分页结构） -->
				<div class="pager-box">
					<span>共{{ clickTotal }}条</span>
					<el-pagination
							:page-sizes="[20,50,100]"
							:page-size="clickPage.pageSize"
							:current-page="clickPage.pageNum"
							:total="clickTotal"
							layout="sizes, prev, pager, next, jumper"
							@size-change="clickSizeChange"
							@current-change="clickPageChange"
					/>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
// 导入全局回车搜索功能（和钱包统计保持一致）
import { useEnterSearch, removeEnterSearch } from '../../../util/enterSearch';
import {
	getProductShareClickerLogCountListPage,
	getProductShareClickerLogListPage,
	getProductShareLogListPage,
	getShareSummary
} from "../../api/api";

export default {
	name: 'ShareStatisticsPage',
	data() {
		return {
			// 当前激活标签（对齐钱包统计的命名）
			activeTab: "forwardStat",
			
			// ============= 转发统计 =============
			statQuery: {
				dateRange: [] // 对齐钱包统计的dateRange命名
			},
			statPage: {
				pageNum: 1, // 统一为pageNum（钱包统计标准）
				pageSize: 20 // 统一为pageSize（钱包统计标准）
			},
			statTotal: 0, // 总条数
			statList: [],
			
			// ============= 转发记录 =============
			recordQuery: {
				productId: "",
				userName: "",
				phone: "",
				dateRange: [] // 对齐钱包统计的dateRange命名
			},
			recordPage: {
				pageNum: 1,
				pageSize: 20
			},
			recordTotal: 0,
			recordList: [],
			
			// ============= 点击记录 =============
			clickQuery: {
				productId: "",
				userName: "",
				phone: "",
				dateRange: [] // 对齐钱包统计的dateRange命名
			},
			clickPage: {
				pageNum: 1,
				pageSize: 20
			},
			clickTotal: 0,
			clickList: [],
			allCount:""
		};
	},
	mounted() {
		// 复用钱包统计的回车搜索逻辑
		useEnterSearch(() => {
			if (this.activeTab === "forwardStat") {
				this.queryStat();
			} else if (this.activeTab === "forwardRecord") {
				this.queryRecord();
			} else if (this.activeTab === "clickRecord") {
				this.queryClick();
			}
		});
	},
	beforeDestroy() {
		// 移除全局回车监听（和钱包统计保持一致）
		removeEnterSearch();
	},
	methods: {
		getShareSummaryFun(){
			getShareSummary().then(res=>{
				if(res.data.success){
					this.allCount = res.data.response
				}
			})
		},
		// 切换标签页重新加载数据（对齐钱包统计的changeSelectValue）
		changeSelectValue(value) {
			console.log("切换标签页：", value);
			if (value.name === "forwardStat") {
				this.statPage.pageNum = 1;
				this.queryStat();
			} else if (value.name === "forwardRecord") {
				this.recordPage.pageNum = 1;
				this.queryRecord();
			} else if (value.name === "clickRecord") {
				this.clickPage.pageNum = 1;
				this.queryClick();
			}
		},
		
		// ========== 转发统计 ==========
		async queryStat() {
			
			let params = {
				pageIndex: this.statPage.pageNum,
				pageSize: this.statPage.pageSize,
				startTime: this.statQuery.dateRange?this.statQuery.dateRange[0]: "",
				endTime: this.statQuery.dateRange?this.statQuery.dateRange[1]: ""
			}
			const res = await getProductShareClickerLogCountListPage(params);
			if (res.data.success){
				this.statTotal = res.data.response.dataCount;
				this.statList = res.data.response.data;
			}
		},
		statSizeChange(val) {
			this.statPage.pageSize = val;
			this.queryStat();
		},
		statPageChange(val) {
			this.statPage.pageNum = val;
			this.queryStat();
		},
		
		// ========== 转发记录 ==========
		async	queryRecord() {
			console.log("查询转发记录", this.recordQuery);
			// this.$message.success("转发记录查询成功");
			let params = {
				pageIndex: this.recordPage.pageNum,
				pageSize: this.recordPage.pageSize,
				startTime: this.recordQuery.dateRange?this.recordQuery.dateRange[0]: "",
				endTime: this.recordQuery.dateRange?this.recordQuery.dateRange[1]: "",
				code: this.recordQuery.productId,
				nickName: this.recordQuery.userName,
				phoneNumber: this.recordQuery.phone,
			}
			const res = await getProductShareLogListPage(params);
			if (res.data.success){
				this.recordTotal = res.data.response.dataCount;
				this.recordList = res.data.response.data;
			}
		},
		resetRecordQuery() {
			this.recordQuery = {
				productId: "",
				userName: "",
				phone: "",
				dateRange: []
			};
			// this.$message.success("已重置转发记录查询条件");
		},
		recordSizeChange(val) {
			this.recordPage.pageSize = val;
			this.queryRecord();
		},
		recordPageChange(val) {
			this.recordPage.pageNum = val;
			this.queryRecord();
		},
		
		// ========== 点击记录 ==========
		async	queryClick() {
			let params = {
				pageIndex: this.clickPage.pageNum,
				pageSize: this.clickPage.pageSize,
				startTime: this.clickQuery.dateRange?this.clickQuery.dateRange[0]: "",
				endTime: this.clickQuery.dateRange?this.clickQuery.dateRange[1]: "",
				code: this.clickQuery.productId,
				nickName: this.clickQuery.userName,
				phoneNumber: this.clickQuery.phone,
			}
			const res = await getProductShareClickerLogListPage(params);
			if (res.data.success){
				this.clickTotal = res.data.response.dataCount;
				this.clickList = res.data.response.data;
			}
		},
		resetClickQuery() {
			this.clickQuery = {
				productId: "",
				userName: "",
				phone: "",
				dateRange: []
			};
			// this.$message.success("已重置点击记录查询条件");
		},
		clickSizeChange(val) {
			this.clickPage.pageSize = val;
			this.queryClick();
		},
		clickPageChange(val) {
			this.clickPage.pageNum = val;
			this.queryClick();
		}
	},
	created() {
		this.queryStat();
		this.getShareSummaryFun();
	}
};
</script>

<style scoped>
/* 复用钱包统计的基础样式 */
.wallet-page {
	width: 98%;
	margin: 20px auto;
	padding: 20px;
	background: #fff;
	box-sizing: border-box;
}

.top-total {
	font-size: 14px;
	color: #333;
	margin-bottom: 15px;
}

.tab-box {
	margin-top: 5px;
}

.query-row {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 15px;
	flex-wrap: wrap;
}

.detail-query {
	padding: 10px;
	background: #f9f9f9;
	border-radius: 4px;
}

.query-item {
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 14px;
	color: #666;
}

.time-box {
	gap: 8px;
}

.pager-box {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 18px;
	font-size: 14px;
	color: #666;
}

/* 合计行样式（保留原有样式并适配） */
.total-row {
	padding: 10px 15px;
	background: #fafafa;
	border: 1px solid #ebeef5;
	border-top: none;
	font-size: 14px;
	font-weight: 500;
	color: #333;
	margin-bottom: 18px;
}

/* 表格样式统一 */
.data-table {
	width: 100%;
	font-size: 13px;
}
</style>